require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-imagicasa-daracombe-kew.json") })
        }
      }, "path---journal-imagicasa-daracombe-kew");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-imagicasa-daracombe-kew!./.cache/json/journal-imagicasa-daracombe-kew.json
// module id = 498
// module chunks = 231608221292675